// frontend/src/features/campaign/components/create/UnsavedChangesReminderModal.js
import React from 'react';

export default function UnsavedChangesReminderModal({
  isOpen,
  onClose,
  onConfirmDiscard,
  onConfirmSave,
  canDirectApprove = true,
  isSaving = false,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="cmp-modal-backdrop"
      onClick={onClose}
      style={{
        zIndex: 1150,
        backgroundColor: 'rgba(15, 23, 42, 0.65)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
        boxSizing: 'border-box',
      }}
    >
      <div
        className="cmp-modal-container"
        style={{
          width: '100%',
          maxWidth: '540px',
          background: '#ffffff',
          borderRadius: '14px',
          overflow: 'hidden',
          boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.25)',
          border: '1px solid #e2e8f0',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div
          style={{
            padding: '16px 20px',
            borderBottom: '1px solid #e2e8f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: '#ffffff',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div
              style={{
                width: '36px',
                height: '36px',
                borderRadius: '8px',
                background: '#fffbeb',
                border: '1px solid #fde68a',
                color: '#d97706',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '15px',
                flexShrink: 0,
              }}
            >
              <i className="fas fa-exclamation-triangle" />
            </div>
            <div>
              <h3 style={{ fontSize: '15px', fontWeight: 700, color: '#0f172a', margin: 0 }}>
                Unsaved Campaign Changes
              </h3>
              <p style={{ fontSize: '12px', color: '#64748b', margin: '2px 0 0 0' }}>
                You have unsaved changes in this campaign.
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            title="Close modal"
            disabled={isSaving}
            style={{
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              color: '#64748b',
              width: '28px',
              height: '28px',
              borderRadius: '6px',
              fontSize: '13px',
              cursor: isSaving ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.15s ease',
            }}
            onMouseEnter={(e) => {
              if (!isSaving) {
                e.currentTarget.style.color = '#0f172a';
                e.currentTarget.style.background = '#f1f5f9';
                e.currentTarget.style.borderColor = '#cbd5e1';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#64748b';
              e.currentTarget.style.background = '#f8fafc';
              e.currentTarget.style.borderColor = '#e2e8f0';
            }}
          >
            <i className="fas fa-times" />
          </button>
        </div>

        {/* Modal Body */}
        <div
          style={{
            padding: '18px 20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '14px',
            background: '#ffffff',
          }}
        >
          {/* Warning Notice Card */}
          <div
            style={{
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: '10px',
              padding: '14px 16px',
            }}
          >
            <div style={{ fontSize: '12.5px', lineHeight: '1.45', color: '#334155' }}>
              <div
                style={{ fontWeight: 700, fontSize: '13px', color: '#0f172a', marginBottom: '3px' }}
              >
                Save or Submit Changes Before Leaving
              </div>
              <div>
                {canDirectApprove ? (
                  <>
                    Leaving without saving will{' '}
                    <strong style={{ color: '#b91c1c' }}>discard your latest modifications</strong>,
                    including any newly imported leads, manual edits, or updated messaging.
                  </>
                ) : (
                  <>
                    Leaving without submitting will{' '}
                    <strong style={{ color: '#b91c1c' }}>discard your latest modifications</strong>.
                    Submit a change request to send your updates to your Manager or Workspace Owner
                    for approval.
                  </>
                )}
              </div>
            </div>
          </div>

          <p style={{ margin: 0, fontSize: '13px', color: '#64748b', lineHeight: '1.45' }}>
            What would you like to do before returning to the Campaigns Catalog?
          </p>
        </div>

        {/* Modal Footer */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 20px',
            borderTop: '1px solid #e2e8f0',
            background: '#f8fafc',
            gap: '10px',
          }}
        >
          <button
            type="button"
            onClick={onClose}
            disabled={isSaving}
            style={{
              fontWeight: 600,
              padding: '8px 14px',
              fontSize: '12.5px',
              borderRadius: '6px',
              cursor: isSaving ? 'not-allowed' : 'pointer',
              background: '#ffffff',
              color: '#334155',
              border: '1px solid #cbd5e1',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              transition: 'all 0.15s ease',
            }}
            onMouseEnter={(e) => {
              if (!isSaving) {
                e.currentTarget.style.background = '#f1f5f9';
                e.currentTarget.style.borderColor = '#94a3b8';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#ffffff';
              e.currentTarget.style.borderColor = '#cbd5e1';
            }}
          >
            <i className="fas fa-arrow-left" style={{ fontSize: '11px', color: '#64748b' }} />{' '}
            Continue Editing
          </button>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <button
              type="button"
              onClick={onConfirmDiscard}
              disabled={isSaving}
              style={{
                fontWeight: 600,
                padding: '8px 14px',
                fontSize: '12.5px',
                borderRadius: '6px',
                background: '#ffffff',
                color: '#dc2626',
                border: '1px solid #fca5a5',
                cursor: isSaving ? 'not-allowed' : 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                transition: 'all 0.15s ease',
              }}
              onMouseEnter={(e) => {
                if (!isSaving) {
                  e.currentTarget.style.background = '#fef2f2';
                  e.currentTarget.style.borderColor = '#ef4444';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#ffffff';
                e.currentTarget.style.borderColor = '#fca5a5';
              }}
            >
              <i className="fas fa-trash-alt" style={{ fontSize: '11px' }} /> Discard &amp; Exit
            </button>

            <button
              type="button"
              onClick={onConfirmSave}
              disabled={isSaving}
              style={{
                fontWeight: 600,
                padding: '8px 16px',
                fontSize: '12.5px',
                borderRadius: '6px',
                cursor: isSaving ? 'not-allowed' : 'pointer',
                background: '#2563eb',
                color: '#ffffff',
                border: '1px solid #1d4ed8',
                boxShadow: '0 1px 2px rgba(37, 99, 235, 0.2)',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                transition: 'background-color 0.15s ease',
              }}
              onMouseEnter={(e) => {
                if (!isSaving) {
                  e.currentTarget.style.background = '#1d4ed8';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#2563eb';
              }}
            >
              {isSaving ? (
                <>
                  <svg
                    className="cmp-dribbble-svg"
                    viewBox="0 0 28 28"
                    width="14"
                    height="14"
                    style={{ display: 'inline-block', verticalAlign: 'middle' }}
                  >
                    <path
                      className="cmp-dribbble-main-star"
                      d="M14 3.5C14 9.299 9.299 14 3.5 14C9.299 14 14 18.701 14 24.5C14 18.701 18.701 14 24.5 14C18.701 14 14 9.299 14 3.5Z"
                      fill="#ffffff"
                    />
                    <circle
                      className="cmp-dribbble-sat-1"
                      cx="21.5"
                      cy="6.5"
                      r="1.5"
                      fill="#ffffff"
                    />
                    <circle
                      className="cmp-dribbble-sat-2"
                      cx="6.5"
                      cy="21.5"
                      r="1.3"
                      fill="#ffffff"
                    />
                    <circle className="cmp-dribbble-sat-3" cx="6" cy="6.5" r="1.1" fill="#ffffff" />
                    <circle
                      className="cmp-dribbble-sat-4"
                      cx="22"
                      cy="21.5"
                      r="1.2"
                      fill="#ffffff"
                    />
                  </svg>
                  Saving...
                </>
              ) : canDirectApprove ? (
                <>
                  <i className="fas fa-save" style={{ fontSize: '11px' }} /> Save Changes &amp; Exit
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane" style={{ fontSize: '11px' }} /> Submit Request
                  &amp; Exit
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
